import React from "react";
import { createUserWithEmailAndPassword, signInWithEmailAndPassword} from "firebase/auth";
import { useState } from "react"
import { auth } from "../Firebase_Config/firebase";
import { Navigate } from "react-router-dom";
import { Alert } from '@mui/material';
import { Link } from "react-router-dom";
import { collection, addDoc, serverTimestamp} from 'firebase/firestore';
import { db } from '../Firebase_Config/firebase';
import "./SignUp.css"; // Import the shared CSS file

const SignUp = () => {
  const initialFormState = {
    email: '',
    password: '',
    confirmPassword: '',
    OrganName: '',
    Name: '',
  };

  const [error, setError] = useState(null);
  const [formData, setFormData] = useState(initialFormState);
  const MAX_RETRY_ATTEMPTS = 3;

  const handleSignUp = async () => {
    // Validate form data
    if (!formData.email || !formData.password || !formData.confirmPassword ||
        !formData.OrganName || !formData.Name ) {
        setError("Please fill out all required fields.");
        return;
    }

    // Check if passwords match
    if (formData.password !== formData.confirmPassword) {
        setError("Passwords do not match.");
        return;
    }
    let retryAttempts = 0;
    while (retryAttempts < MAX_RETRY_ATTEMPTS) {
        try {      
         
            const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
            const user = userCredential.user;
            
            // Add user data to Firestore
            const timestamp = new Date().toLocaleString();
            const userRef = collection(db, "users");
            const docRef = await addDoc(userRef, {
                userId: user.uid,
                email: formData.email,
                OrganName: formData.OrganName,
                Name: formData.Name,
                RoleTitle: formData.RoleTitle,
                isAdmin: false,
                isThreatComplete: false,
                isConformityComplete: false,
                DashReroute: false,
                HasPaid: false,
                lastLogin: serverTimestamp(),               
                timestamp
            });
            
            if (docRef.id) {
                setFormData(initialFormState);
                console.log('User has been added successfully');
                window.location.href = '/ConformityAnalysis';
            } else {
                retryAttempts++;
                console.log(`Retry attempt ${retryAttempts}`);
            }
               
        } catch (error) {
            // Handle errors
            console.error("Error signing up:", error);
            setError(error.message);
             return;
        }
    }
    setError("Failed to create account. Please contact the  Adminsitrator at info@assentian.com");
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'turnover' || name === 'NumOfEmplyo') {
        // Check if value is a number
        if (isNaN(value)) {
            setError("Please enter a valid number for turnover and number of employees.");
            return;
        }
    }
    setError(null)
    setFormData({ ...formData, [name]: value });
  };
 
  const d = new Date();
  let year = d.getFullYear();
  return (
    <div style={{
      backgroundImage: `linear-gradient(195deg, rgba(66, 66, 74, 0.6), rgba(25, 25, 25, 0.6)), url('bg.jpeg')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      height: '100vh'
  }}>
      <div className="auth-containerUp">
          <div className="auth-boxUp">
              <div className="sign-in-headerUp">
                  <h2 className="Signh2Up">Sign Up</h2>
              </div>
              {error && <Alert severity="error">{error}</Alert>}
              <div>
                  <form onSubmit={(e) => { e.preventDefault(); handleSignUp(); }}>
                      <div className="form-row">
                          <input className="form_inputUp" type="text" id="Name" name="Name" value={formData.ACRA_Num} onChange={handleInputChange} placeholder="Name" />
                          <input className="form_inputUp" type="text" id="OrganName" name="OrganName" value={formData.OrganName} onChange={handleInputChange} placeholder="Organisation Name" />
                          <input className="form_inputUp" type="text" id="RoleTitle" name="RoleTitle" value={formData.RoleTitle} onChange={handleInputChange} placeholder="Role Title" />
                          
                      
                          <input className="form_inputUp" type="text" id='email' name="email" value={formData.email} onChange={handleInputChange} placeholder="Email" />
                          <input className="form_inputUp" type="password" id='password' name="password" value={formData.password} onChange={handleInputChange} placeholder="Password" />
                          <input className="form_inputUp" type="password" id="confirmPassword" name="confirmPassword" value={formData.confirmPassword} onChange={handleInputChange} placeholder="Confirm Password" />
                      </div>
                      <button className="SignbuttonUp" type="submit">Sign Up</button>
                  </form>
                  <p className="sign-up-textUp">
                      Already have an account? <a href="/SignIn">Sign In</a>
                  </p>
              </div>
          </div>
      </div>
      <p className='copyright sign'>© Copyright, {year} Assentian. All Rights Reserved</p>
  </div>
  );
};

export default SignUp;
